import React, { useEffect, useState } from "react";
import {
  useCreateRoomCaseMutation,
  useUpdateRipeningToMovedMutation,
  useUpdateRipeningToSortingMutation,
} from "./ripeningApi";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import { Col, Row } from "react-bootstrap";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import InputWithIcon from "../../../components/shared/fields/InputWithIcon";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import Button from "../../../components/shared/buttons/button";
import { useGetRoomsQuery } from "../sorting/sortingApi";
import toast from "react-hot-toast";
import { useGetRipeningSummaryQuery } from "../dashboard/ripeingDashboardApi";
import useTranslator from "../../../hooks/useTranslator";

import {
  MAX_EVAPORATION_PRCNT_ALLOWED
} from "../../../helpers/constants";

import { ceilToTwoDecimal, convertToUserTimezone, formatPalletName } from "../../../helpers/Utils";
import { SETTINGS } from "../../../helpers/systemVariable";

const RoomByIdModal = ({ show, setShow, roomCase, mode, room }) => {
 
  const { _t } = useTranslator();
  const currentDate = convertToUserTimezone(null, "YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const { data: roomData } = useGetRoomsQuery({ date });
  const [enteredCases, setEnteredCases] = useState("");
  const [evaporationError, setEvaporationError] = useState("");

  const totalRoomCapacity = roomData?.data.find(
    (data) => data.id === room.id
  )?.cases_capacity;
  const usedCapcity = roomData?.data.find(
    (data) => data.id === room.id
  )?.total_cases;
  const [tab, setTab] = useState("ripening");

  const palletWeightBeforeRipening = ceilToTwoDecimal(
    roomCase.fruit_entered_in_kg +
      roomCase.case_entered * Number(SETTINGS.EMPTY_ORANGE_CASE_WEIGHT) +
      Number(SETTINGS.PLASTIC_EMPTY_PALLET_WEIGHT)
  );
  const { data: summaryData } = useGetRipeningSummaryQuery({ tab });

  const [createRoomCase, { isLoading: isCreating }] =
    useCreateRoomCaseMutation();
  const [updateToSorting, { isLoading: isUpdatingToSort }] =
    useUpdateRipeningToSortingMutation();
  const [updateToMoved, { isLoading: isUpdatingToMove }] =
    useUpdateRipeningToMovedMutation();
  const [percentage, setPercentage] = useState("0");
  const [palletWeightAfterRipening, setPalletWeightAfterRipening] = useState(mode === "edit" ? 0 : "");  
  const expectedExitDateFormat = "YYYY-MM-DD";

  const initialFormData = {
    pallet_code: "",
    entered_date_time: convertToUserTimezone(null),
    // expected_date_to_ripening: "",
    exit_date_time: convertToUserTimezone(null),
    room_id: room.id,
    room_name: room.name,
    fruit_entered_in_kg: "",
    case_entered: enteredCases,
    status: "",
    weight_before_ripening: "",
    weight_after_ripening: "",
    expected_date_to_exit: convertToUserTimezone(null, expectedExitDateFormat),
    expected_date_to_exit_for_text: convertToUserTimezone(null, "DD-MM-YYYY"),
    kg_evaporated: percentage,
  };
  const [formData, setFormData] = useState(initialFormData);
  useEffect(() => {
    if ((mode === "edit" || mode === "moved" || mode === "view") && roomCase) {
      const updatedFormData = { ...initialFormData };

      for (const key in roomCase) {
        if (key in initialFormData) {
          if (key === "entered_date_time") {
            updatedFormData[key] = convertToUserTimezone(roomCase[key]);
          } else if (key === "expected_date_to_ripening") {
            updatedFormData[key] =  convertToUserTimezone(roomCase[key],"YYYY-MM-DDTHH:mm");             
          } else if (key === "expected_date_to_exit") {                    
            updatedFormData[key] = convertToUserTimezone(roomCase[key], expectedExitDateFormat);
          } else {
            if (
              key === "weight_before_ripening" &&
              !roomCase["weight_before_ripening"]
            ) {
              updatedFormData[key] = roomCase["fruit_entered_in_kg"] || 0;
            } else if (key == "exit_date_time") {
              updatedFormData[key] = convertToUserTimezone(roomCase[key],"YYYY-MM-DDTHH:mm");              
            } else {
              updatedFormData[key] = roomCase[key];
            }
          }
        }
      }

      setPercentage(roomCase.kg_evaporated);
      setEnteredCases(roomCase.case_entered);      

      setFormData(updatedFormData);
    } else {      
      setFormData(initialFormData);
    }
  }, [mode, roomCase, show, room]);
  // console.log(`Mode :: ${mode}`);
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    // prevent double submission
    if (isCreating || isUpdatingToSort || isUpdatingToMove) return;

    if (evaporationError) {
      toast.error(_t("moisture_loss_exceeds_limit", `Moisture loss cannot exceed ${ Number(SETTINGS.MAX_EVAPORATION_PRCNT_ALLOWED) }%.`));
      return;
    }

    if (
      mode !== "add" &&
      (palletWeightAfterRipening === "" ||
        palletWeightAfterRipening === null ||
        palletWeightAfterRipening === undefined)
    ) {
      toast.error(
        _t(
          "pallet_weight_after_ripening_required",
          "Pallet Weight after Ripening is required."
        )
      );
      return;
    }

    const updatedFormData = {
      ...formData,
    };

    const mutation =
      mode === "add"
        ? createRoomCase
        : mode === "moved"
        ? updateToMoved
        : updateToSorting;

    if (
      mode === "add" &&
      updatedFormData.fruit_entered_in_kg > summaryData?.data.total_kg_on_floor
    ) {
      toast.error(_t("weight_exceeds_floor_available", "The weight entered cannot exceed the available weight on the floor."));
      return;
    }

    if (mode !== "add") {
      const initialValue = roomCase.fruit_entered_in_kg;

      if (
        updatedFormData.fruit_entered_in_kg > initialValue &&
        summaryData?.data.total_kg_on_floor <
          updatedFormData.fruit_entered_in_kg - initialValue
      ) {
        toast.error(_t("weight_exceeds_floor_available", "The weight entered cannot exceed the available weight on the floor."));
        return;
      }
    }

    if (mode !== "edit" && mode !== "moved" ) {
      if (updatedFormData.case_entered > totalRoomCapacity - usedCapcity) {
        toast.error(_t("room_max_capacity_reached", "This room has reached its maximum capacity."));
        return;
      }
    }    


    try {
      const payload =
        mode === "add"
          ? updatedFormData // ✅ Fixed: Use `updatedFormData`
          : {
              id: roomCase.id,
              requestBody: { ...updatedFormData, request_from: "ripening" },
            };
      await mutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const palletWeightAfterRipeningChangeHandler = (e) => {
    let { value } = e.target;

    if (value > palletWeightBeforeRipening) {
      value = palletWeightBeforeRipening;
    }

    setPalletWeightAfterRipening(value);

    let weightAfterRipening =
      value -
      (roomCase.case_entered * Number(SETTINGS.EMPTY_ORANGE_CASE_WEIGHT) +
        Number(SETTINGS.PLASTIC_EMPTY_PALLET_WEIGHT));
    if (weightAfterRipening < 1) {
      weightAfterRipening = 0;
    }

    weightAfterRipening = ceilToTwoDecimal(weightAfterRipening);
    let evaporatedAmount = roomCase.fruit_entered_in_kg - weightAfterRipening;
    if (evaporatedAmount < 0) {
      evaporatedAmount = 0;
    }
    evaporatedAmount = ceilToTwoDecimal(evaporatedAmount);
    const amount = getPercentage(
      evaporatedAmount,
      roomCase.fruit_entered_in_kg
    );

    // Add validation here
    if (amount > Number(SETTINGS.MAX_EVAPORATION_PRCNT_ALLOWED)) {
      setEvaporationError(`${_t(
          "evaporation_error",
          "Evaporated percentage is greater than :limit% (:value%)",
          { limit: Number(SETTINGS.MAX_EVAPORATION_PRCNT_ALLOWED), value: amount }
        )}`);
    } else {
      setEvaporationError("");
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      weight_before_ripening: formData.fruit_entered_in_kg,
      kg_evaporated: amount,
      weight_after_ripening: weightAfterRipening,
    }));

    setPercentage(amount);
  };

  const handleClose = () => {
    setShow(false);
  };
  const calculateTotalCases = (fruitKg) => {
    return Math.ceil(fruitKg / Number(SETTINGS.ORANGE_CASE_FRUIT_WEIGHT));
  };
  const getPercentage = (diff, total) => {
    if (total === 0) return 0;
    const percentage = (diff / total) * 100;
    return parseFloat(percentage.toFixed(2));
  };
  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "pallet_weight_after_ripening") {
      if (value > palletWeightBeforeRipening) {
        value = palletWeightBeforeRipening;
      }

      let weightAfterRipening =
        value -
        ceilToTwoDecimal(
          roomCase.case_entered * Number(SETTINGS.EMPTY_ORANGE_CASE_WEIGHT) +
            Number(SETTINGS.PLASTIC_EMPTY_PALLET_WEIGHT)
        );

      if (weightAfterRipening < 1) {
        weightAfterRipening = 0;
      }
      const evaporatedAmount =
        roomCase.fruit_entered_in_kg - weightAfterRipening;
      const amount = getPercentage(
        evaporatedAmount,
        roomCase.fruit_entered_in_kg
      );

      // Update formData with supplier_id and batch_code in one go
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
        weight_before_ripening: formData.fruit_entered_in_kg,
        kg_evaporated: amount,
        weight_after_ripening: weightAfterRipening,
      }));

      setPercentage(amount);
    } else if (name === "fruit_entered_in_kg") {
      const cases = calculateTotalCases(value);

      setFormData((prevFormData) => ({
        ...prevFormData,

        [name]: value,
        // case_entered: cases,
      }));

      setEnteredCases(cases);
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  const renderFormFields = () => {
    return mode === "add" ? (
      <>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_pallet_code", "Pallet Code")}
            type="text"
            name="pallet_code"
            value={formData.pallet_code}
            onChange={handleChange}
            placeholder={_t("placeholder_pallet_code", "PALLETXXX")}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_entered_date_time", "Entered Date/Time")}
            type="text"
            name="entered_date_time"
            value={formData.entered_date_time}
            disabled={true}
            onChange={handleChange}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t(
              "label_expected_date_to_ripening",
              "Expected Date to Move in Ripening Room"
            )}
            type="date"
            name="expected_date_to_ripening"
            value={formData.expected_date_to_ripening}
            onChange={handleChange}
            min={date}
          />          
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_room", "Room")}
            type="text"
            name="room_id"
            value={formData.room_id}
            disabled={true}
            onChange={handleChange}
          />
        </Col>
        <Col lg={6}>
          <InputWithIcon
            label={_t("label_fruit_entered_in_kg", "Fruit entered in KG")}
            type="number"
            name="fruit_entered_in_kg"
            icon={RefreshSvg}
            value={formData.fruit_entered_in_kg}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_case_entered", "Case Entered")}
            type="number"
            name="case_entered"
            value={enteredCases}
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col>

        <Col lg={6}>
          <SelectBox
            label={_t("label_status", "Status")}
            type="text"
            name="status"
            value={formData.status}
            options={[
              { value: "ripening", label: _t("status_ripening", "Ripening") },
              {
                value: "sorting",
                label: _t("status_ready_for_sorting", "Ready For Sorting"),
              },
            ]}
            onChange={handleChange}
            // disabled={mode === "view"}
          />
        </Col>
      </>
    ) : mode === "edit" ? (
      <>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_pallet_code", "Pallet Code")}
            type="text"
            name="pallet_code"
            value={formatPalletName(formData.pallet_code)}            
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_entered_date", "Entered Date")}
            type="text"
            name="entered_date_time"
            value={formData.entered_date_time}
            disabled={true}
            onChange={handleChange}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_expected_exit_date", "Expected Exit Date")}
            type="date"
            name="expected_date_to_exit"
            value={formData.expected_date_to_exit}
            onChange={handleChange}
            min={roomCase?.exit_date_time_to_ripening ? convertToUserTimezone(roomCase?.exit_date_time_to_ripening, "YYYY-MM-DD") : ""}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_room", "Room")}
            type="text"
            name="room_id"
            value={formData.room_id}
            disabled={true}
            onChange={handleChange}
          />
        </Col>
        <Col lg={6}>
          <InputWithIcon
            label={_t("label_fruit_entered_in_kg", "Fruit entered in KG")}
            type="number"
            name="fruit_entered_in_kg"
            // icon={RefreshSvg}
            value={formData.fruit_entered_in_kg}
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_case_entered", "Case Entered")}
            type="number"
            name="case_entered"
            value={formData.case_entered}
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col>

        <Col lg={6}>
          <SelectBox
            label={_t("label_status", "Status")}
            type="text"
            name="status"
            value={formData.status}
            options={[
              { value: "ripening", label: _t("status_ripening", "Ripening") },
              {
                value: "sorting",
                label: _t("status_ready_for_sorting", "Ready For Sorting"),
              },
            ]}
            onChange={handleChange}
            // disabled={mode === "view"}
          />
        </Col>
      </>
    ) : (
      <>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_pallet_code", "Pallet Code")}
            type="text"
            name="pallet_code"
            value={formatPalletName(formData.pallet_code)}            
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_entered_date_time", "Entered Date/Time")}
            type="text"
            name="entered_date_time"
            value={formData.entered_date_time}
            disabled={true}
            onChange={handleChange}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_expected_exit_date", "Expected Exit Date")}
            type="text"
            name="expected_date_to_exit"
            value={formData.expected_date_to_exit_for_text}
            onChange={handleChange}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_exit_date_time", "Exit Date and Time")}
            type="datetime-local"
            name="exit_date_time"
            value={formData.exit_date_time}
            onChange={handleChange}
            min={roomCase?.exit_date_time_to_ripening ? convertToUserTimezone(roomCase?.exit_date_time_to_ripening,"YYYY-MM-DD") : ""}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t(
              "pallet_weight_before_ripening",
              "Pallet Weight before Ripening "
            )}
            type="number"
            placeholder={"0"}
            name="pallet_weight_before_ripening"
            value={palletWeightBeforeRipening}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t(
              "label_weight_before_ripening",
              "Fruit KG Before Ripening"
            )}
            placeholder={"0"}
            type="number"
            name="weight_before_ripening"
            value={
              formData.fruit_entered_in_kg || formData.weight_before_ripening
            }
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithIcon
            label={_t(
              "pallet_weight_after_ripening",
              "Pallet Weight after Ripening "
            )}
            type="number"
            name="pallet_weight_after_ripening"
            icon={RefreshSvg}
            value={palletWeightAfterRipening}
            onChange={palletWeightAfterRipeningChangeHandler}
            disabled={mode === "view"}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("label_weight_after_ripening", "Fruit KG After Ripening")}
            type="number"
            placeholder={"0"}
            name="weight_after_ripening"
            value={formData.weight_after_ripening}
            onChange={handleChange}
            disabled
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("evaporated", "% KG evaporated")}
            type="text"
            name="kg_evaporated"
            value={percentage}
            disabled={true}
            onChange={handleChange}
            error={evaporationError}
          />
          {/* {evaporationError && (
            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
              {evaporationError}
            </div>
          )} */}
        </Col>

        <Col lg={6}>
          <SelectBox
            label={_t("label_status", "Status")}
            type="text"
            name="status"
            value={formData.status}
            options={[
              {
                value: "sorting",
                label: _t("status_ready_for_sorting", "Ready For Sorting"),
              },
              { value: "moved", label: _t("moved", "Moved") },
            ]}
            onChange={handleChange}
            disabled={mode === "view"}
          />
        </Col>
      </>
    );
  };
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add"
          ? _t("add_cases_in_ripening_room", "Add Cases in Ripening Room")
          : mode === "edit"
          ? _t("ripening_to_sorting", "Ripening To Sorting")
          : ` ${_t("move_cases_from_room", "Move Cases from")} ${room?.name}`
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          {mode !== "view" && (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <Button
                label={_t("save_changes", "Save Changes")}
                size="small"
                onClick={handleSubmit}
                disabled={isCreating || isUpdatingToSort || isUpdatingToMove || evaporationError}
                title={evaporationError ? _t("evaporation_limit_exceeded", "Evaporation percentage limit cannot exceed 15%") : ""}
              />
              {/* {evaporationError && (
                <div style={{ 
                  color: 'red', 
                  fontSize: '12px', 
                  marginTop: '8px',
                  textAlign: 'right'
                }}>
                  {evaporationError}
                </div>
              )} */}
            </div>
          )}
        </Col>
      </Row>
    </CommonModal>
  );
};

export default RoomByIdModal;
